const initRecaptcha = () => {
  const forms = document.querySelectorAll('[data-form]');

  if (!forms.length) {
    return;
  }

  forms.forEach((form) => {
    const response = form.querySelector('[data-recaptcha-response]');

    if (response) {
      grecaptcha.ready(() => {
        grecaptcha.execute('6LdvTnAqAAAAAJTQHfdvB4DT56XPOQstp5ax7Gq6', {action: 'submit'}).then((token) => {
          response.value = token;
        });
      });
    }
  });
};

export {initRecaptcha};
